var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-actions",
      class: {
        "c-table-actions__red": _vm.shouldCellBeRed,
        "c-table-actions__blue": _vm.shouldCellBeBlue,
      },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("edit-violation-modal", { ref: "editModal" }),
      _c("div", { staticClass: "c-table-actions__wrapper" }, [
        _c("div", { staticClass: "c-table-actions__action" }, [
          _vm.record.doesRequireExplanatory && _vm.record.explanatory.entity
            ? _c(
                "svg",
                {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover",
                        content: "Просмотр объяснительной",
                        placement: "bottom",
                      },
                      expression:
                        "{\n          container: '#app',\n          trigger: 'hover',\n          content: 'Просмотр объяснительной',\n          placement: 'bottom',\n        }",
                      modifiers: { html: true },
                    },
                  ],
                  attrs: {
                    width: "13",
                    height: "15",
                    viewBox: "0 0 13 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: { click: _vm.viewExplanatory },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M12 6V14H1V1H7M12 6H7V1M12 6L7 1",
                      stroke: "#8E9CBB",
                      "stroke-width": "2",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.record.doesRequireExplanatory && !_vm.record.explanatory.entity
            ? _c(
                "svg",
                {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover",
                        content: "Написать объяснительную",
                        placement: "bottom",
                      },
                      expression:
                        "{\n          container: '#app',\n          trigger: 'hover',\n          content: 'Написать объяснительную',\n          placement: 'bottom',\n        }",
                      modifiers: { html: true },
                    },
                  ],
                  attrs: {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 15 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: { click: _vm.addExplanatory },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M14 1L14.9439 1.33035C15.0708 0.967765 14.9788 0.564532 14.7071 0.292894C14.4355 0.0212557 14.0323 -0.0707638 13.6697 0.0561414L14 1ZM9.45 14L8.53619 14.4061C8.70271 14.7808 9.08108 15.0159 9.49076 14.9992C9.90044 14.9825 10.2584 14.7174 10.3939 14.3304L9.45 14ZM1 5.55L0.66965 4.60614C0.282649 4.74159 0.0175448 5.09956 0.000831127 5.50924C-0.0158825 5.91892 0.219182 6.29729 0.593863 6.46381L1 5.55ZM13.0562 0.669648L8.50614 13.6696L10.3939 14.3304L14.9439 1.33035L13.0562 0.669648ZM10.3638 13.5939L7.76384 7.74387L5.93621 8.55614L8.53619 14.4061L10.3638 13.5939ZM7.25616 7.23619L1.40614 4.63619L0.593863 6.46381L6.44389 9.06381L7.25616 7.23619ZM1.33035 6.49386L14.3304 1.94386L13.6697 0.0561414L0.66965 4.60614L1.33035 6.49386ZM13.2929 0.292893L6.14292 7.44289L7.55713 8.85711L14.7071 1.70711L13.2929 0.292893Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "c-table-actions__action violation-edit-action" },
          [
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover",
                    content: "Редактировать",
                    placement: "bottom",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover',\n          content: 'Редактировать',\n          placement: 'bottom',\n        }",
                  modifiers: { html: true },
                },
              ],
              attrs: { icon: "edit", size: "iconic" },
              on: { click: _vm.editViolation },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "c-table-actions__action" },
          [
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover",
                    content: "Удалить",
                    placement: "bottom",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover',\n          content: 'Удалить',\n          placement: 'bottom',\n        }",
                  modifiers: { html: true },
                },
              ],
              attrs: {
                icon: { icon: "trash", color: "secondary" },
                size: "iconic",
              },
              on: { click: _vm.deleteViolation },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }